import { render, staticRenderFns } from "./tab-bookprice-list.vue?vue&type=template&id=4a3dc7e8&scoped=true&"
import script from "./tab-bookprice-list.vue?vue&type=script&lang=js&"
export * from "./tab-bookprice-list.vue?vue&type=script&lang=js&"
import style0 from "./tab-bookprice-list.vue?vue&type=style&index=0&id=4a3dc7e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3dc7e8",
  null
  
)

export default component.exports